import React from "react";
import Head from "next/head";
import Header from "../../common/header/Header";
import Footer from "../../common/footer/Footer";

export default function PrivacyPolicy() {
  return (
    <main className="page-wrapper">
      <Head>
        <title>Modulabs | Contact Us</title>
      </Head>
      <Header className="header-transparent" />
      <div className="height-650">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="inner pt--80 text-center">
                <h2 className="h1 display-one">Thank you for contacting us</h2>
                <p>
                  We have received your message and a member of our staff will
                  be reaching out to shortly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </main>
  );
}
